<template>
    <div class="favourite-modal-move">
        <h1>{{ message.textMoveProduct }}</h1>
        <p>{{ message.textMoveProduct }}</p>
        <form class="favourite-modal-move__form" @submit.prevent="moveItems">
            <label v-for="item in favourite">
                <input type="radio" name="groupId" :value="item.id"/>
                {{ item.name }}
            </label>
            <div class="favourite-modal-move__form-group">
                <button type="submit" class="def-button">{{ message.textMove }} </button>
                <span @click="close">{{ message.btnCancel }}</span>
            </div>
        </form>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: "favourite-modal-move",
    props:{
        item: {
            type: [Object, Array],
        },
    },
    computed: {
        ...mapState({
            favourite: ({favourite}) => favourite?.data?.group,
            action: ({favourite}) => favourite?.data?.routes?.moveLikes['params-example-data'].action,
            message: ({ favourite }) => favourite?.data?.message,
        }),
        checkIds() {
            if ( this.item ) {
                return this.item ;
            } else {
                return this.item.offer && this.item.offer.id || this.item.id ;
            }
        },
    },
    methods: {
        close() {
            this.$DefModal.hide();
        },

        moveItems( { target } ){
            const formData = new FormData(target);
            if ( this.checkIds.length > 1) {
                this.checkIds.forEach( (el, i) => {
                    formData.append(`id[${i}]`, el);
                })
            } else {
                formData.append('id', this.checkIds);
            }
            // formData.append('id', data);
            formData.append('action', this.action);

            this.$store.dispatch('favourite/moveItemInFavoriteGroup', formData);

            this.close();
        }
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.favourite-modal-move{
    &__form{
        display: flex;
        flex-direction: column;
    }
    p{
        margin: 8px 0 24px;
        @include point-md{
            font-size: rem(16);
        }
    }
    svg{
        width: 13px;
        height: 14px;
        fill: #757575;
        cursor: pointer;

    }
    h1{
        font-size: rem(14);
        font-weight: 500;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        @include point-md{
            font-size: rem(18);
        }
    }
    span{
        border-bottom: 0.0625rem dashed #618EAF;
        color: #618EAF;
        cursor: pointer;
        margin-left: 15px;
        font-size: rem(12);
        text-transform: uppercase;
        letter-spacing: 0.1em;
    }
    .def-button{
        transition: 0.2s linear background;
        text-transform: uppercase;
        &:hover{
            background: rgba(97, 142, 175, 0.8);
            transition: 0.2s linear background;
        }
    }
    label{
        font-size: rem(14);
        text-transform: uppercase;
        margin-bottom: 20px;

        @include point-md{
            font-size: rem(16);
        }
    }
}
</style>